import React, { Component } from "react";
import { Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import moment from 'moment'

import { Grid } from "@material-ui/core";
import RaisedButton from "material-ui/RaisedButton";
import Snackbar from "material-ui/Snackbar";
import TextField from "material-ui/TextField";
import TimePicker from 'material-ui/TimePicker'
import MenuItem from "material-ui/MenuItem";
import SelectField from 'material-ui/SelectField'
import Checkbox from 'material-ui/Checkbox'


import { getUserSettings, setUserSettings } from "../../reducers/integrations/resources";
import { setUserSettingState } from "../../reducers/user/actions";

import mixpanel from "../../utils/mixpanel";
import transformSchedMsg from "../../utils/schedmsg";

import './index.css'
import constants from "../../constants";

class UserAvailability extends Component {
    componentWillMount = async () => {
        const notCustomStartTime = {
            value: this.constructDateTime(17),
            error: '',
        }

        const notCustomEndTime = {
            value: this.constructDateTime(8),
            error: '',
        }

        this.setState({
            acknowledgmentMsg: "Thank you for your message. I'm out of the office right now, but will respond when I get back online.",
            acknowledgmentMsgError: '',
            notCustomStartTime,
            notCustomEndTime,
            showSnackbar: false,
            snackbarMsg: '',
            scheduleMode: 'everyday',
            availabilitySched: [
                'Sunday',
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday'
            ],
            acknowledgmentEnabled: false
        })

        let settings = await getUserSettings()
        settings = settings.data

        const constructedSched = this.state.availabilitySched.map((sched, index) => {
            return {
                key: index,
                name: sched,
                value: sched.toLowerCase(),
                timeError: '',
                startTime: this.constructDateTime(17),
                endTime: this.constructDateTime(8),
                isActive: true
            }
        })

        this.setState({ availabilitySched: constructedSched })

        if(settings) {
            const {
                acknowledgmentMsg,
                notCustomStartTime: ackStrtTime,
                notCustomEndTime: ackEndTime,
                scheduleMode,
                availabilitySched,
                acknowledgmentEnabled
            } = settings

            if(ackStrtTime) {
                notCustomStartTime.value = moment(ackStrtTime, 'hh:mm A').toDate()
            }

            if(ackEndTime) {
                notCustomEndTime.value = moment(ackEndTime, 'hh:mm A').toDate()
            }

            if(availabilitySched) {
                const constructedSched = availabilitySched.map((sched, index) => {
                    return {
                        key: sched.key,
                        name: sched.name,
                        value: sched.name.toLowerCase(),
                        timeError: '',
                        startTime: moment(sched.startTime, 'hh:mm A').toDate(),
                        endTime: moment(sched.endTime, 'hh:mm A').toDate(),
                        isActive: sched.isActive
                    }
                })

                this.setState({ availabilitySched: constructedSched })
            }
            
            this.setState({
                acknowledgmentMsg: acknowledgmentMsg || this.state.acknowledgmentMsg,
                notCustomStartTime,
                notCustomEndTime,
                scheduleMode: scheduleMode || this.state.scheduleMode,
                acknowledgmentEnabled: acknowledgmentEnabled || this.state.acknowledgmentEnabled
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        const { userSettings } = nextProps;

        if(userSettings) {
            this.setState({
                acknowledgmentEnabled: userSettings.acknowledgmentEnabled
            })
        }
    }

    constructDateTime = hrs => {
        const dateTime = new Date();

        dateTime.setHours(hrs)
        dateTime.setMinutes(0)
        dateTime.setSeconds(0)

        return dateTime
    }

    clearFields = (field, index=null, subField='') => {
        let state = this.state;

        if(field === 'schedmsgs') {
            if(subField === 'isActive') {
                state['errorMsgs'][index]['msg'] = '';
                state['errorMsgs'][index]['sched'] = '';
            } else {
                state['errorMsgs'][index][subField] = '';
            }
        } else {
            state.inviteMsgError = '';
        }

        this.setState(state)
    }

    validateTime = (startTime, endTime) => {
        if (!(startTime instanceof Date) || !(endTime instanceof Date)) {
            return false
        }

        startTime = moment(startTime)
        endTime = moment(endTime)

        /**
         * Check if the end time is earlier that the start time
         * commented out due to spec changes
         */
        // if (endTime.isBefore(startTime)) {
        //     return false
        // }

        return true
    }
    
    handleOnChange = (field, isSelect, idx = null, subField='') => (obj, arg1, arg2) => {
        const state = this.state

        const ackTimeFields = ['notCustomStartTime', 'notCustomEndTime']
        const schedTimeFields = ['startTime', 'endTime']

        let value = arg1
        if (isSelect) {
            value = arg2
        }

        // prevent change if there is invalid time error before switching
        if(field === 'scheduleMode') {
            const checkHasError = state.availabilitySched.filter(sched => sched.timeError)
            if(
                checkHasError.length ||
                state['notCustomStartTime'].error ||
                state['notCustomEndTime'].error
            ) {
                this.setState({
                    showSnackBar: true,
                    snackbarMsg: 'Some field(s) need your attention.'
                })
                return;
            }
        }
            

        if (ackTimeFields.includes(field)) {
            state[field].value = value

            state['notCustomStartTime'].error = ''
            state['notCustomEndTime'].error = ''

            const isTimeValid = this.validateTime(
                state['notCustomStartTime'].value,
                state['notCustomEndTime'].value,
            )

            if (!isTimeValid) {
                state[field].error = 'Selected time is invalid'
            }
        } else if(field === 'availabilitySched') {
            state[field][idx][subField] = value
            state[field][idx]['timeError'] = ''

            if(schedTimeFields.includes(subField)) {

                const isTimeValid = this.validateTime(
                    state[field][idx]['startTime'],
                    state[field][idx]['endTime'],
                )

                if (!isTimeValid) {
                    state[field][idx]['timeError'] = 'Selected time is invalid'
                }
            }
        } else {
            state[field] = value
        }

        this.setState(state)
    }

    validateFields = () => {
        let state = this.state;
        let hasError = false;

        const checkHasError = state.availabilitySched.filter(sched => sched.timeError)

        if(!state.acknowledgmentMsg) {
            state.acknowledgmentMsgError = 'Required';
            hasError = true
        }
        
        if(
            state['notCustomStartTime'].error ||
            state['notCustomEndTime'].error ||
            checkHasError.length
        ) {
            hasError = true
        }

        if(hasError) {
            state.showSnackBar = true;
            state.snackbarMsg = 'Some field(s) need your attention.';
        }

        this.setState(state)

        return hasError;
    }

    saveSettingsProcedure = () =>{

		// get updated data in case avilability toggle above is updated
        getUserSettings().then(res => {
            let settings = res.data;

            if(settings) {
                let selectedDays = [false, true, true, true, true, true, false]
                const {
                    acknowledgmentMsg,
                    scheduleMode,
                    availabilitySched,
                    notCustomStartTime: ackStartTime,
                    notCustomEndTime: ackEndTime,
                    acknowledgmentEnabled
                } = this.state;
                const {
                    selectedDays: sDays,
                    schedmsgs
                } = settings

                // construct selectedDays for API
                selectedDays = selectedDays.fill(false)
                sDays.forEach((days) => {
                    selectedDays[days] = true
                })

                const transformed = availabilitySched.map((sched, index) => {
                    return {
                        key: index,
                        name: sched.name,
                        startTime: moment(sched.startTime).format('hh:mm A'),
                        endTime: moment(sched.endTime).format('hh:mm A'),
                        isActive: sched.isActive
                    }
                })

                const data = {
                    ...settings,
                    selectedDays,
                    acknowledgmentMsg,
                    scheduleMode,
                    availabilitySched: transformed,
                    notCustomStartTime: moment(ackStartTime.value).format('hh:mm A'),
                    notCustomEndTime: moment(ackEndTime.value).format('hh:mm A'),
                    acknowledgmentEnabled
                }

                if(schedmsgs) {
                    data.schedmsgs = transformSchedMsg(schedmsgs);
                }

                // remove location
                delete data.location;
                
                mixpanel.track('office hours:update', { data })

                setUserSettings(data)
                    .then(() => {
                        this.setState({
                            showSnackBar: true,
                            snackbarMsg: 'Settings has been saved.',
                        })

                        this.props.setUserSettingState({ userSettings: data })
                    })
            }
        })
        
    }

    saveSettings = async() => {
        if(this.validateFields()) {
            this.setState({ showSnackBar: true })
            return;
        }

        this.saveSettingsProcedure()

    }
    
    render() {
        const labelSize = 6;
        const settingSize = 6;
        const { notCustomStartTime, notCustomEndTime, availabilitySched } = this.state;

        let styles = {
            gridFluid: {
                height: '100%',
                backgroundColor: '#FBFBFB',
                overflowY: 'auto',
                paddingBottom: '150px',
            }
        }

        const constructedSchedules = this.state.availabilitySched.map((sched, idx) => {
            return (
                <div key={idx} className="flex-container" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                    <Col lg={2} xs={12} className="flex-container">
                        <Checkbox
                            className="available-days"
                            value={availabilitySched[idx].isActive}
                            defaultChecked={availabilitySched[idx].isActive}
                            onCheck={this.handleOnChange('availabilitySched',  false, idx, 'isActive')}
                        />
                    </Col>
                    <Col lg={4} xs={12} className="flex-container">
                        <h4>{sched.name}</h4>
                    </Col>
                    <Col lg={6} xs={12} className="flex-container">
                        <TimePicker
                            className="setting-time"
                            hintText="Start time"
                            value={availabilitySched[idx].startTime}
                            errorText={availabilitySched[idx].timeError}
                            errorStyle={{ width: 'max-content' }}
                            minutesStep={5}
                            onChange={this.handleOnChange('availabilitySched', false, idx, 'startTime')}
                            inputStyle={{ textAlign: 'right' }}
                            disabled={!availabilitySched[idx].isActive}
                        />
                        <span id="time-separator">-</span>
                        <TimePicker
                            className="setting-time"
                            hintText="End time"
                            value={availabilitySched[idx].endTime}
                            errorStyle={{ width: 'max-content' }}
                            minutesStep={5}
                            onChange={this.handleOnChange('availabilitySched',  false, idx, 'endTime')}
                            disabled={!availabilitySched[idx].isActive}
                        />
                    </Col>
                </div>
            )
        })

        return(
            <Grid fluid style={styles.gridFluid}>
                <Snackbar
                    open={this.state.showSnackBar}
                    message={this.state.snackbarMsg}
                    autoHideDuration={4000}
                    onRequestClose={() => this.setState({ showSnackBar: false })}
                />
                <div>
                    <div style={{ height: '80px', backgroundColor: '#F5F5F5'}}>
                        <div style={{ height: '100%', width: '90%', padding: '20px', margin: '0 auto'}}>
                            <h2 style={{ margin: 0 }}>Office Hours</h2>
                        </div>
                    </div>
                    <div className="availability-setting-content">
                        <div>
                            <div className="setting-container">
                                <Row className='setting-container no-border'>
                                    <Col xs={12} style={{ marginBottom: '10px' }}>
                                        <Checkbox
                                            label="Enable Office Hours feature"
                                            checked={this.state.acknowledgmentEnabled}
                                            onCheck={this.handleOnChange('acknowledgmentEnabled')}
                                            inputStyle={{ width: '32px', height: '32px' }}
                                            labelStyle={{ fontWeight: 400 }}
                                        />
                                    </Col>
                                    <Col xs={12}>
                                        <p>
                                            With Office Hours, we'll keep candidates engaged,
                                            even when you're asleep, or away for the weekend!
                                        </p>
                                        <p>
                                            By setting your office hours and days below,
                                            when you receive a 1-1 text message "after hours",
                                            we'll send your customized "Out of Office" text message
                                            to your contact, so they know you may not respond right
                                            away.
                                        </p>
                                    </Col>
                                </Row>
                                <Row className='setting-container no-border'>
                                    <Col xs={labelSize} className="setting-label">
                                        <span className="title">Schedule:</span>
                                        <div className="flex-container" style={{ justifyContent: 'space-between'}}>
                                            <Col lg={6} xs={12} className="flex-container">
                                                <SelectField
                                                    hintText="0"
                                                    value={this.state.scheduleMode}
                                                    onChange={this.handleOnChange('scheduleMode', true)}
                                                    fullWidth={true}
                                                >
                                                    <MenuItem primaryText="Every day" value="everyday" key="everyday" />
                                                    <MenuItem primaryText="Weekdays" value="weekdays" key="weekdays" />
                                                    <MenuItem primaryText="Custom" value="custom" key="custom" />
                                                </SelectField>
                                            </Col>
                                            {this.state.scheduleMode !== 'custom' ?
                                                <Col lg={6} xs={12} className="flex-container">
                                                    <TimePicker
                                                        className="setting-time"
                                                        hintText="Start time"
                                                        value={notCustomStartTime.value}
                                                        errorText={notCustomStartTime.error}
                                                        errorStyle={{ width: 'max-content' }}
                                                        minutesStep={5}
                                                        onChange={this.handleOnChange('notCustomStartTime')}
                                                        inputStyle={{ textAlign: 'right' }}
                                                    />
                                                    <span id="time-separator">-</span>
                                                    <TimePicker
                                                        className="setting-time"
                                                        hintText="End time"
                                                        value={notCustomEndTime.value}
                                                        errorText={notCustomEndTime.error}
                                                        errorStyle={{ width: 'max-content' }}
                                                        minutesStep={5}
                                                        onChange={this.handleOnChange('notCustomEndTime')}
                                                    />
                                                </Col> 
                                                : ''}
                                        </div>
                                        {this.state.scheduleMode === 'custom' ?  
                                            <div style={{ marginTop: '20px' }}>
                                                {constructedSchedules}
                                            </div>
                                        : ''}
                                    </Col>
                                    
                                    <Col className="setting-description" xs={settingSize}>
                                        Set the schedule that you are available and inside the office.
                                    </Col>
                                </Row>
                                
                                <Row className="setting-container no-border">
                                    <Col xs={labelSize} className="setting-label">
                                    <span className="title">Out of office message:</span>
                                    <TextField
                                        id="acknowledgmentMsg"
                                        fullWidth={true}
                                        multiLine={true}
                                        value={this.state.acknowledgmentMsg}
                                        errorText={this.state.acknowledgmentMsgError}
                                        onChange={this.handleOnChange('acknowledgmentMsg')}
                                        rows={3}
                                        maxLength={constants.maxMessageLength}
                                        hintStyle={{ bottom: 'unset', top: '20px', left: '5px' }}
                                        className="acknowledge-msg-box"
                                        textareaStyle={{
                                            borderRadius: '10px',
                                            outline: '1px solid #ccc',
                                            padding: '5px',
                                            minHeight: '82px',
                                        }}
                                        underlineShow={false}
                                    />
                                    <span className="message-count">
                                        {`(${this.state.acknowledgmentMsg.length}/${constants.maxMessageLength})`}
                                    </span>
                                    </Col>
                                    <Col xs={settingSize} className="setting-description">
                                        <p>
                                            Send a message to the candidate when you are
                                            out of the office based on the schedule that you set above.
                                        </p>
                                        <p><em>This only applies to user 1-1 texting numbers.</em></p>
                                    </Col>
                                </Row>
                            </div>
                            
                            <div className="sched-msg-save">
                                <Col xs={12} style={{ textAlign: 'right' }}>
                                    <RaisedButton
                                        label="Save"
                                        style={{ marginTop: '10px' }}
                                        primary={true}
                                        onClick={this.saveSettings}
                                    />
                                </Col>
                            </div>
                        </div>
                    </div>
                </div>
            </Grid>
        )
    }
}

const mapStateToProps = (state) => {
    const { user: { userSettings } } = state

    return { userSettings }
}

const mapDispatchToProps = (dispatch) => {
    return {
		setUserSettingState(data) {
			dispatch(setUserSettingState(data));
		},
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserAvailability)